import React, { Component } from 'react';
import Constants from '../../../definitions/constants';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import toastr from 'toastr';

import Select from '../common/inputs/select';
import TextBox from '../common/inputs/textBox';
import Button from '../common/inputs/button';
import TextAutocompleteSuggestBox from '../common/inputs/textAutocompleteSuggestBox';
import CheckBox from '../common/inputs/checkBox';
import HoverTooltip from '../common/interface/hoverTooltip';

const initialObjectState = {
  mapping_field: "",
  mapping_external_field: "",
  mapping_path: "",
  mapping_sufix: "",
  mapping_prefix: "",
  mapping_filter: "",
  mapping_ignore_path_errors: false,
  mapping_filter_nils: false,
  mapping_fixed_value: "",
  transposition_virtual_property: "",
}

class ConnectorFieldsMappingList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState),
      toEditObjectPosition: null,   
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState),
      suggestSearchValue: "",
    };
  }

  componentDidMount() {
    this.props.handleSetDefaultFields(this.props.defaultFieldsList, this.props["data-path"], true, this.props.isAssociationConnectorMapping);
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(!prevState.showOverlay && this.state.showOverlay) {
      InterfaceTooling.bringObjectEditorInputIntoView();
    }
  }
  
  isValidObject = (object) => {   
    toastr.options = Constants.interface.tostrOptions;
    if(!object.mapping_field){
      toastr.error(intl.formatMessage({ id: "endpointsConnectorsAdmin.endpointMappingFields.emptyFieldsError"}));
      return false;
    }
    return true;
  };
    
  handleAddButtonClick = (event) => {
    if(this.editItemInput) {
      this.editItemInput.focus();
    }
  };

  handleCancelAdd = (event) => {
    this.setState({
      showOverlay: false,
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
  };

  handleChangeAddItem = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toAddObject = JavascriptUtilsTooling.deepCopy(this.state.toAddObject);
    toAddObject[event.currentTarget.dataset.path] = value;
    if(event.currentTarget.dataset.path == "transposition_virtual_property"){
      toAddObject.mapping_external_field = "";
      toAddObject.mapping_fixed_value = "";
      toAddObject.mapping_ignore_path_errors = false;
    }
    this.setState({
      showOverlay: true,
      toAddObject: toAddObject
    });    
  };

  handleOnEnterAddItem = (event) => {
    if(this.addItemSaveButton) {
      this.addItemSaveButton.click();
    }
  };

  handleSaveAddItem = (event) => {
    if(this.isValidObject(this.state.toAddObject)) {
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });
      this.handleSetSuggestionBoxSearchValue()
    }
  };

  handleClickEdit = (event) => {
    let itemIndex = event.currentTarget.dataset.index;    
    let objectToEdit = JSON.parse(event.currentTarget.dataset.value);
    this.setState({    
      showOverlay: true,  
      toEditObjectPosition: itemIndex,
      toEditObject: objectToEdit
    });
  };

  handleChangeEdit = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toEditObject = JavascriptUtilsTooling.deepCopy(this.state.toEditObject);
    toEditObject[event.currentTarget.dataset.path] = value;
    if(event.currentTarget.dataset.path == "transposition_virtual_property"){
      toEditObject.mapping_external_field = "";
      toEditObject.mapping_fixed_value = "";
      toEditObject.mapping_ignore_path_errors = false;
    }
    this.setState({
      toEditObject: toEditObject
    });  
  };

  handleCancelEdit = (event) => {
    this.setState({
      showOverlay: false,
      toEditObjectPosition: null,
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
  };

  handleSaveEditItem = (event) => {
    if(this.isValidObject(this.state.toEditObject, this.state.toEditObjectPosition)) {
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toEditObjectPosition: null,
        toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });
      this.handleSetSuggestionBoxSearchValue()
    }     
  };

  handleOnEnterEditItem = (event) => {
    if(this.editItemSaveButton) {
      this.editItemSaveButton.click();      
    }   
  };

  handleDeleteItem = (event) => {
    event.currentTarget.columnSelector = true; 
    this.props.onChange(event);
  }

  handleSetSuggestionBoxSearchValue = (value = "") => {
    this.setState({
      suggestSearchValue: value
    });
  }

  render() {
    const {
      className,
      disabled,
      values,
      onChange,
      handleSetDefaultFields, //function: Function to be called on component mount to set the component's default items (auto-called on component mount)
      handleLoadExternalFields, //function: Function to be called when the load external fields button is clicked
      externalFieldsList, //array: Array of strings with the external fields to show
      defaultFieldsList,  //array: Array of strings with the default fields to show (and also to be used as selectValues for the mapping_field select)
      blockExternalFieldsButton, //boolean: If true, the load external fields button will be disabled
      hideExternalFieldsButton, //boolean: If true, the load external fields button will be hidden
      excludeCalculationUnitMapping, //boolean: If true, the calculation unit mapping will be excluded from the mapping list
      excludePeriodMapping,  //boolean: If true, the period mapping will be excluded from the mapping list
      dimensionsList, //array: Array of dimension descriptors to find the period and calculation unit dimension
      isAssociationConnectorMapping, //boolean: If true, the component is used for association connector mappingm which helps when resetting the default fields
      disableAddItem, //boolean: If true, the add item UI will not be shown
      metricGroupUsePivotColumn, //boolean: If true, sets the mapping component for pivot column usage (only for metrics group connector type)
    } = this.props;
    const dataPath = this.props["data-path"];
    let blockAdd = false;

    //Checking and setting values for the mapping_external_field suggestionBox input
    let externalFieldsOptions = []
    if(externalFieldsList && externalFieldsList.length > 0) {
      externalFieldsOptions = InterfaceTooling.getSelectArrayFromArray(externalFieldsList, true);
    }

    //Settting the values for the mapping_field select    
    let mappingFieldSelectValues = (defaultFieldsList && defaultFieldsList.length>0) ? InterfaceTooling.getSelectArrayFromArray(defaultFieldsList, true) : []

    return (
      <div className={"custom-input free-text-list select-list object-editor object-template-headers-editor" + (className ? " " + className : "") + " select-list-no-search" + (className ? " " + className : "") + " select-list-no-search" + (this.state.showOverlay ? " free-text-list-overlay" : "")}>
        {this.state.showOverlay && (<div className="free-text-list-overlay-item"></div>)}
        <div className="free-text-list-label">
          <div className="free-text-list-info-label-wrapper">
            <FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.header"/>
          </div>
          {(!disabled && !hideExternalFieldsButton) &&
            <Button
              className="auto_generate_button"
              onClick={handleLoadExternalFields}
              labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.loadFieldsButtonHeader"/>}
              disabled={blockExternalFieldsButton}
            />
          }
        </div>
          <div className="free-text-list-list-wrapper">
            {values && values.map((item,i) => {
              if(this.state.toEditObjectPosition == i) {
                return (
                  <div key={i} className="free-text-list-list-item free-text-list-list-item-edit">
                    <div className="free-text-list-list-item-inner object-editor-inputs">
                      <div className="object-editor-inputs-linebreak"> 
                        <Select 
                          className="free-text-list-list-add-item"
                          value={this.state.toEditObject.mapping_field}
                          labelLocale={item.isDefaultField ?  "" : <FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_field"/>}
                          options={mappingFieldSelectValues}
                          onChange={this.handleChangeEdit}
                          data-path={"mapping_field"}
                          disabled={item.isDefaultField}
                        />
                        {(!this.state.toEditObject.transposition_virtual_property) && (
                          <React.Fragment>
                            <TextAutocompleteSuggestBox
                              className="free-text-list-list-edit-item"
                              onChange={this.handleChangeEdit}
                              data-path={"mapping_external_field"}
                              suggestionsList={externalFieldsOptions}
                              value={this.state.toEditObject.mapping_external_field}
                              showClearSearchButton={false}
                              minSearchLength={0}
                              labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_external_field"/>}
                              searchValue={this.state.suggestSearchValue}
                              handleSetSuggestionBoxSearchValue={this.handleSetSuggestionBoxSearchValue}
                              disabled={this.state.toEditObject.mapping_fixed_value}
                            />
                            <TextBox
                              className="free-text-list-list-edit-item"
                              styleType={Constants.interface.inputs.styleType.OUTLINED}
                              onChange={this.handleChangeEdit}
                              data-path={"mapping_path"}
                              value={this.state.toEditObject.mapping_path}
                              onKeyEsc={this.handleCancelEdit}
                              onKeyEnter={this.handleOnEnterEditItem}
                              type={Constants.interface.inputs.type.TEXT}
                              labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_path"/>}
                              disabled={this.state.toEditObject.mapping_fixed_value}
                            />
                          </React.Fragment>
                        )}
                      </div>
                      <div className="object-editor-inputs-linebreak">
                        <TextBox
                          className="free-text-list-list-edit-item"
                          styleType={Constants.interface.inputs.styleType.OUTLINED}
                          onChange={this.handleChangeEdit}
                          data-path={"mapping_prefix"}
                          value={this.state.toEditObject.mapping_prefix}
                          onKeyEsc={this.handleCancelEdit}
                          onKeyEnter={this.handleOnEnterEditItem}
                          type={Constants.interface.inputs.type.TEXT}
                          labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_prefix"/>}
                          disabled={this.state.toEditObject.mapping_fixed_value}
                        />
                        <TextBox
                          className="free-text-list-list-edit-item"
                          styleType={Constants.interface.inputs.styleType.OUTLINED}
                          onChange={this.handleChangeEdit}
                          data-path={"mapping_sufix"}
                          value={this.state.toEditObject.mapping_sufix}
                          onKeyEsc={this.handleCancelEdit}
                          onKeyEnter={this.handleOnEnterEditItem}
                          type={Constants.interface.inputs.type.TEXT}
                          labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_sufix"/>}
                          disabled={this.state.toEditObject.mapping_fixed_value}
                        />
                        <TextBox
                          className="free-text-list-list-edit-item"
                          styleType={Constants.interface.inputs.styleType.OUTLINED}
                          onChange={this.handleChangeEdit}
                          data-path={"mapping_filter"}
                          value={this.state.toEditObject.mapping_filter}
                          onKeyEsc={this.handleCancelEdit}
                          onKeyEnter={this.handleOnEnterEditItem}
                          type={Constants.interface.inputs.type.TEXT}
                          labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_filter"/>}
                          disabled={this.state.toEditObject.mapping_fixed_value}
                        />
                      </div>
                      <div className="object-editor-inputs-linebreak mapping_errors_linebreak">
                        {(!this.state.toEditObject.transposition_virtual_property) && (
                          <CheckBox
                            className={"free-text-list-list-edit-item mapping_errors_ignore_path_errors_checkbox" + ((this.state.toEditObject.mapping_fixed_value) ? " disabled" : "")}
                            data-path={"mapping_ignore_path_errors"}
                            value={this.state.toEditObject.mapping_ignore_path_errors}
                            onChange={this.handleChangeEdit}
                            labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_ignore_path_errors"/>}
                            disabled={this.state.toEditObject.mapping_fixed_value}
                          />
                        )}
                        <CheckBox
                          className={"free-text-list-list-edit-item mapping_errors_filter_nils_checkbox" + ((this.state.toEditObject.mapping_fixed_value) ? " disabled" : "")}
                          data-path={"mapping_filter_nils"}
                          value={this.state.toEditObject.mapping_filter_nils}
                          onChange={this.handleChangeEdit}
                          labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_filter_nils"/>}
                          disabled={this.state.toEditObject.mapping_fixed_value}
                        />
                        {(!this.state.toEditObject.transposition_virtual_property) && (
                          <TextBox
                            className="free-text-list-list-edit-item"
                            styleType={Constants.interface.inputs.styleType.OUTLINED}
                            onChange={this.handleChangeEdit}
                            data-path={"mapping_fixed_value"}
                            value={this.state.toEditObject.mapping_fixed_value}
                            onKeyEsc={this.handleCancelEdit}
                            onKeyEnter={this.handleOnEnterEditItem}
                            type={Constants.interface.inputs.type.TEXT}
                            labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_fixed_value"/>}
                          />
                        )}
                      </div>
                      {(metricGroupUsePivotColumn) && (
                        <div className="object-editor-inputs-linebreak">
                          <Select
                            className="free-text-list-list-add-item"
                            value={this.state.toEditObject.transposition_virtual_property}
                            labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.transposition_virtual_property"/>}
                            options={InterfaceTooling.getSelectArray("selectKeys.endpoint.endpoint_connector_mapping_filter.mapping_column_pivot_options","endpointsConnectorsAdmin.fields.selectValues.transpositionColumnPropertyLabels")}
                            onChange={this.handleChangeEdit}
                            data-path={"transposition_virtual_property"}
                          />
                        </div>
                      )}
                    </div>
                    {(!disabled && this.state.showOverlay) && (
                      <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-edit">
                        <i 
                          ref={(input) => { this.editItemSaveButton = input; }}
                          className="fas fa-save"
                          data-index={i}   
                          data-connectormappingeditor={"true"}                 
                          data-value={JSON.stringify(this.state.toEditObject)}
                          data-path={dataPath}
                          data-edit={"true"}
                          onClick={this.handleSaveEditItem}                      
                        />         
                        <i className="fas cancel-action fa-times-circle" onClick={this.handleCancelEdit}/>
                      </div>
                    )}
                  </div>
                );
              }
              else {
                let periodDimensionName = dimensionsList.find(dimension => dimension.system_entity_class == "Period");
                periodDimensionName = periodDimensionName ? periodDimensionName.name : "";
                let calculationUnitDimensionName = dimensionsList.find(dimension => dimension.system_entity_class == "CalculationUnit");
                calculationUnitDimensionName = calculationUnitDimensionName ? calculationUnitDimensionName.name : "";
                let isPeriodDimensionAndExcluded = excludePeriodMapping && item.mapping_field == periodDimensionName;
                let isCalculationUnitDimensionAndExcluded = excludeCalculationUnitMapping && item.mapping_field == calculationUnitDimensionName;
                let itemInnerText = ""
                itemInnerText += item.mapping_field;
                let isItemInOptionalList = [
                  intl.formatMessage({id: "endpointsConnectorsAdmin.calculationUnitAssociationsDefaultFields.association_id"}),
                ].includes(item.mapping_field) 
                let isIncompleteItem = !(item.mapping_field && (item.mapping_external_field || item.transposition_virtual_property)) && 
                  !isItemInOptionalList && !isPeriodDimensionAndExcluded && !isCalculationUnitDimensionAndExcluded && !item.mapping_fixed_value;
                if(isIncompleteItem){
                  itemInnerText += " (" + intl.formatMessage({id: "endpointsConnectorsAdmin.endpointMappingFields.incompleteDataText"}) + ")";
                }
                else if(isPeriodDimensionAndExcluded || isCalculationUnitDimensionAndExcluded){
                  itemInnerText += " -> " + " (" + intl.formatMessage({id: "endpointsConnectorsAdmin.endpointMappingFields.autoMappedText"}) + ")";
                }
                else if(item.mapping_fixed_value) {
                  itemInnerText += " -> " +  intl.formatMessage({id:"endpointsConnectorsAdmin.mappingFixedValueItemLabel"}) + ": " + item.mapping_fixed_value;
                }
                else if(item.mapping_external_field) {
                  itemInnerText += " -> " + item.mapping_external_field;                  
                  itemInnerText += (item.mapping_filter) ? " (" + item.mapping_filter + ")" : "";
                  itemInnerText += item.mapping_path ? (" ["+ intl.formatMessage({id: "endpointsConnectorsAdmin.endpointFieldMapping.routeLabel"})+": "+ item.mapping_path + "]") : ""
                }
                else if(metricGroupUsePivotColumn && item.transposition_virtual_property) {
                  itemInnerText += " -> " + intl.formatMessage({id: "endpointsConnectorsAdmin.endpointFieldMapping.transpositionPropertyLabel"}) + ": "
                  itemInnerText += "\"" + intl.formatMessage({id: "endpointsConnectorsAdmin.fields.selectValues.transpositionColumnPropertyLabels." + item.transposition_virtual_property}) + "\"";
                }
                return (
                  <div key={i} className={"free-text-list-list-item" + ((isIncompleteItem) ? " free-text-list-list-item-required" : "")}>
                    <div title={itemInnerText} className="free-text-list-list-item-inner">
                      {itemInnerText}
                    </div>
                    {(!disabled) && (
                      <div className="free-text-list-list-item-action-buttons">
                        {(!isPeriodDimensionAndExcluded && !isCalculationUnitDimensionAndExcluded) && (
                          <i 
                            className="fas fa-edit"
                            onClick={this.handleClickEdit}
                            data-index={i}
                            data-value={JSON.stringify(item)}
                          />
                        )}
                        {(!item.isDefaultField) && (
                          <i
                            className="fas delete-action fa-trash"                          
                            data-index={i}
                            data-delete={"true"}
                            data-connectormappingeditor={"true"}
                            data-value={JSON.stringify(item)}
                            data-path={dataPath}
                            onClick={this.handleDeleteItem}
                          />
                        )}
                      </div>
                    )}
                  </div>
                );
              }
            })}
            {(!disableAddItem) && (              
              <div className="free-text-list-list-item free-text-list-list-item-add">
                <div className="free-text-list-list-item-inner">
                  {(!disabled && !blockAdd && !this.state.toEditObjectPosition) && (
                    <div className="object-editor-inputs">
                      <div className="object-editor-inputs-linebreak"> 
                          <Select 
                            className="free-text-list-list-add-item"
                            value={this.state.toAddObject.mapping_field}
                            labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_field"/>}
                            options={mappingFieldSelectValues}
                            onChange={this.handleChangeAddItem}
                            data-path={"mapping_field"}
                          />
                          {(!this.state.toAddObject.transposition_virtual_property) && (
                            <React.Fragment>
                              <TextAutocompleteSuggestBox
                                className="free-text-list-list-add-item"
                                labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_external_field"/>}
                                onChange={this.handleChangeAddItem}
                                value={this.state.toAddObject.mapping_external_field}
                                data-path={"mapping_external_field"}
                                suggestionsList={externalFieldsOptions}
                                showClearSearchButton={false}
                                minSearchLength={0}
                                searchValue={this.state.suggestSearchValue}
                                handleSetSuggestionBoxSearchValue={this.handleSetSuggestionBoxSearchValue}
                                disabled={this.state.toAddObject.mapping_fixed_value}
                              />
                              <TextBox
                                className="free-text-list-list-edit-item"
                                styleType={Constants.interface.inputs.styleType.OUTLINED}
                                onChange={this.handleChangeAddItem}
                                data-path={"mapping_path"}
                                value={this.state.toAddObject.mapping_path}
                                onKeyEsc={this.handleCancelAdd}
                                onKeyEnter={this.handleOnEnterAddItem}
                                type={Constants.interface.inputs.type.TEXT}
                                labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_path"/>}
                                disabled={this.state.toAddObject.mapping_fixed_value}
                              />
                            </React.Fragment>
                          )}
                        </div>
                        <div className="object-editor-inputs-linebreak">
                          <TextBox
                            className="free-text-list-list-edit-item"
                            styleType={Constants.interface.inputs.styleType.OUTLINED}
                            onChange={this.handleChangeAddItem}
                            data-path={"mapping_prefix"}
                            value={this.state.toAddObject.mapping_prefix}
                            onKeyEsc={this.handleCancelAdd}
                            onKeyEnter={this.handleOnEnterAddItem}
                            type={Constants.interface.inputs.type.TEXT}
                            labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_prefix"/>}
                            disabled={this.state.toAddObject.mapping_fixed_value}
                          />
                          <TextBox
                            className="free-text-list-list-edit-item"
                            styleType={Constants.interface.inputs.styleType.OUTLINED}
                            onChange={this.handleChangeAddItem}
                            data-path={"mapping_sufix"}
                            value={this.state.toAddObject.mapping_sufix}
                            onKeyEsc={this.handleCancelAdd}
                            onKeyEnter={this.handleOnEnterAddItem}
                            type={Constants.interface.inputs.type.TEXT}
                            labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_sufix"/>}
                            disabled={this.state.toAddObject.mapping_fixed_value}
                          />
                          <TextBox
                            className="free-text-list-list-edit-item"
                            styleType={Constants.interface.inputs.styleType.OUTLINED}
                            onChange={this.handleChangeAddItem}
                            data-path={"mapping_filter"}
                            value={this.state.toAddObject.mapping_filter}
                            onKeyEsc={this.handleCancelAdd}
                            onKeyEnter={this.handleOnEnterAddItem}
                            type={Constants.interface.inputs.type.TEXT}
                            labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_filter"/>}
                            disabled={this.state.toAddObject.mapping_fixed_value}
                          />
                        </div>
                        <div className="object-editor-inputs-linebreak mapping_errors_linebreak">
                          {(!this.state.toAddObject.transposition_virtual_property) && (
                            <CheckBox
                              className={"free-text-list-list-edit-item mapping_errors_ignore_path_errors_checkbox" + ((this.state.toAddObject.mapping_fixed_value) ? " disabled" : "")}
                              data-path={"mapping_ignore_path_errors"}
                              value={this.state.toAddObject.mapping_ignore_path_errors}
                              onChange={this.handleChangeAddItem}
                              labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_ignore_path_errors"/>}
                              disabled={this.state.toAddObject.mapping_fixed_value}
                            />
                          )}
                          <CheckBox
                            className={"free-text-list-list-edit-item mapping_errors_filter_nils_checkbox" + ((this.state.toAddObject.mapping_fixed_value) ? " disabled" : "")}
                            data-path={"mapping_filter_nils"}
                            value={this.state.toAddObject.mapping_filter_nils}
                            onChange={this.handleChangeAddItem}
                            labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_filter_nils"/>}
                            disabled={this.state.toAddObject.mapping_fixed_value}
                          />
                          {(!this.state.toAddObject.transposition_virtual_property) && (
                            <TextBox
                              className="free-text-list-list-edit-item"
                              styleType={Constants.interface.inputs.styleType.OUTLINED}
                              onChange={this.handleChangeAddItem}
                              data-path={"mapping_fixed_value"}
                              value={this.state.toAddObject.mapping_fixed_value}
                              onKeyEsc={this.handleCancelAdd}
                              onKeyEnter={this.handleOnEnterAddItem}
                              type={Constants.interface.inputs.type.TEXT}
                              labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.mapping_fixed_value"/>}
                            />
                          )}
                        </div>
                        {(metricGroupUsePivotColumn) && (
                          <div className="object-editor-inputs-linebreak">
                            <Select
                              className="free-text-list-list-add-item"
                              value={this.state.toAddObject.transposition_virtual_property}
                              labelLocale={<FormattedMessage id="endpointsConnectorsAdmin.fields.endpoint_connector_mapping.transposition_virtual_property"/>}
                              options={InterfaceTooling.getSelectArray("selectKeys.endpoint.endpoint_connector_mapping_filter.mapping_column_pivot_options","endpointsConnectorsAdmin.fields.selectValues.transpositionColumnPropertyLabels")}
                              onChange={this.handleChangeAddItem}
                              data-path={"transposition_virtual_property"}
                            />
                          </div>
                        )}
                    </div>
                  )}
                </div>
                {(!disabled && !blockAdd && this.state.showOverlay && !this.state.toEditObjectPosition) && (
                  <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-add">
                    <i 
                      ref={(input) => { this.addItemSaveButton = input; }}
                      className="fas fa-save"
                      data-connectormappingeditor={"true"}
                      data-value={JSON.stringify(this.state.toAddObject)}
                      data-path={dataPath}
                      onClick={this.handleSaveAddItem}   
                    />
                    <i 
                      className="fas cancel-action fa-times-circle"
                      onClick={this.handleCancelAdd}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
      </div>
    );
  }
}

export default ConnectorFieldsMappingList;



// WEBPACK FOOTER //
// ./source/client/components/endpointsconnectorsAdmin/connectorFieldsMappingList.jsx